'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _ = require('../');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _DiversityEeoStatement = require('./DiversityEeoStatement.css');

var _DiversityEeoStatement2 = _interopRequireDefault(_DiversityEeoStatement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiversityEeoStatement = (_dec = (0, _reactCssModules2.default)(_DiversityEeoStatement2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DiversityEeoStatement, _Component);

  function DiversityEeoStatement(props) {
    (0, _classCallCheck3.default)(this, DiversityEeoStatement);
    return (0, _possibleConstructorReturn3.default)(this, (DiversityEeoStatement.__proto__ || (0, _getPrototypeOf2.default)(DiversityEeoStatement)).call(this, props));
  }

  (0, _createClass3.default)(DiversityEeoStatement, [{
    key: 'render',
    value: function render() {
      var ussifProfile = _config2.default.ussifFundsDiversityEeo[this.props.fundId];
      var r = ussifProfile.r;
      var result = _config2.default.ussifFundsDiversityEeoOptions[r];
      var uid = ussifProfile.s[this.props.shareclassId];
      var url = uid ? 'https://charts.ussif.org/mfpc/fund_profile_display.php?FundID=' + uid : 'https://charts.ussif.org/mfpc';
      var ussifLogo = require('../../../static/images/ussif-memberlogo.png');
      return _react2.default.createElement(
        'div',
        { styleName: 'eeo-wrap' },
        _react2.default.createElement('img', {
          styleName: 'img',
          src: ussifLogo,
          alt: 'Member of USSIF'
        }),
        _react2.default.createElement(
          'div',
          { styleName: 'lede' },
          'This fund is a member of a sustainable and responsible investing group, and has a posted policy on their consideration of diversity and equal employment opportunity policies and practices relating to employees, company ownership or contractors.'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'statement-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'statement' },
            result,
            '. \xA0',
            _react2.default.createElement(
              _.Link,
              {
                to: url, title: this.props.shareName + ' | USSIF',
                xstrong: true
              },
              'More',
              _react2.default.createElement(_.LinkIcon, null)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'contact' },
          'US-SIF member fund managers: want to update your statement? \xA0',
          _react2.default.createElement(
            _.Link,
            {
              to: _config2.default.links.contact,
              title: 'Contact us to update your diversity and EEO investment statements',
              xstrong: true
            },
            _react2.default.createElement(
              'strong',
              null,
              'Contact us',
              _react2.default.createElement(_.LinkIcon, { faclass: 'fa-envelope-o' })
            )
          )
        )
      );
    }
  }]);
  return DiversityEeoStatement;
}(_react.Component), _class2.propTypes = {
  fundId: _react.PropTypes.string.isRequired,
  shareclassId: _react.PropTypes.string.isRequired,
  shareName: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = DiversityEeoStatement;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DiversityEeoStatement/DiversityEeoStatement.js
// module id = 1290
// module chunks = 0